// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"177":"home","243":"skills","417":"experience","421":"contacts","443":"about","609":"team"}[chunkId] + "." + {"177":"2c8aa462","243":"2968024f","417":"7bac31cb","421":"4081c9f7","443":"4aa2b2c8","609":"053b34e0"}[chunkId] + ".chunk.js";
};